import classNames from "classnames";
import styles from "./swith.module.scss";

interface SwitchInterface {
  value: boolean;
  label?: string;
  onChange: (e) => void;
  isDisabled?: boolean;
}

const Switch = ({ value, label, isDisabled, onChange }: SwitchInterface) => {
  return (
    <div
      className={classNames(styles["wrapper"], {
        [styles["wrapper--disabled"]]: isDisabled
      })}
    >
      <label className={styles["label"]}>{label}</label>
      <label className={styles["switch"]}>
        <input
          type="checkbox"
          onChange={!isDisabled ? onChange : undefined}
          checked={value}
          disabled={isDisabled}
        />
        <span className={styles["slider"]}></span>
      </label>
    </div>
  );
};

export default Switch;
